import React from 'react'

export const CountryContext = React.createContext();
